import React from 'react';

export default function Footer() {
  return (
    <footer className="text-center py-3 text-muted small">
      &copy; {new Date().getFullYear()} Banque Artesia Nederland N.V.. All rights reserved.
    </footer>
  );
}
